import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import styles from './styles.module.scss'
import { formatDate } from 'src/utils/date'

interface ListAuthorProps {
  authorData: {
    authorSlug: string
    authorImage: string
    authorFullName: string
    createdAt: string
  }
}

const ListAuthor: React.FC<ListAuthorProps> = ({ authorData }) => {
  return (
    <div className={styles.author}>
      <Link href={`/author/${authorData.authorSlug}`} passHref>
        <Image
          className={styles.author__image}
          src={authorData.authorImage}
          alt=''
          width={24}
          height={24}
        />
        <p>{authorData.authorFullName}</p>
      </Link>
      <span>•</span>
      <p>{formatDate(authorData.createdAt)}</p>
    </div>
  )
}

export default ListAuthor
